import React, {useEffect, useState} from "react";
import styles from "./UpdateCachePrompt.module.scss";
import {usePWAUpdate} from "@/hooks/usePwaUpdate/usePwaUpdate";
import Box from "../Box/Box";
import Button from "../Button/Button";
import {useSelector} from "react-redux";
import {selectSyncState} from "@/features/sync/syncSelectors";

export default function UpdateCachePrompt({isLoading = false}) {
  const {isSynchronising = false} = useSelector(selectSyncState);
  const {needRefresh, setNeedRefresh, updateServiceWorker} = usePWAUpdate();
  const [isReloading, setIsReloading] = useState(false);

  useEffect(() => {
    const onChunkFailed = e => {
      setNeedRefresh(true);
    };

    window.addEventListener("app:chunk-failed", onChunkFailed);
    return () => window.removeEventListener("app:chunk-failed", onChunkFailed);
  }, []);

  const handleReload = () => {
    setIsReloading(true);
    updateServiceWorker(true);
  };

  if (!needRefresh || isSynchronising || isLoading) return null;

  return (
    <>
      <div className={styles.backdrop}></div>
      <Box className={`px-3 py-4 ${styles.container}`} fullHeight={false}>
        <h3 className="mb-2">New version available</h3>
        <p className="lh-base text-pretty">
          We've noted that you're using an older version of the app. Please click the reload button to update the app to
          the latest version to ensure you have the latest features and security updates.
        </p>
        <Button isLoading={isReloading} loadingText="Reloading..." disabled={isReloading} onClick={handleReload}>
          Reload
        </Button>
      </Box>
    </>
  );
}
